
import { defineComponent } from 'vue';
import { AppCard, AppButton } from '@/components';
import { useGameMatchEdit } from '@/modules/game/match/model/edit';
import { formatDate, renderOption } from '@/common/utils/helpers';
import { GameMatchOptions, GameMatchCostState } from '@/modules/game/match/model/mixins';
import { ROUTE_NAME_GAME } from '@/modules/game/router';

export default defineComponent({
    name: ROUTE_NAME_GAME.MATCH.DETAIL,
    components: { AppCard, AppButton },
    setup() {
        const { model, actions } = useGameMatchEdit();

        return { model, formatDate, actions, ROUTE_NAME_GAME, GameMatchOptions, GameMatchCostState, renderOption };
    }
});
